import { IconButton as ChakraIconButton } from '@chakra-ui/react';

type IconButtonProps = React.ComponentProps<typeof ChakraIconButton>;

const IconButton = ({ children, ...props }: Readonly<IconButtonProps>) => {
  return <ChakraIconButton {...props}>{children}</ChakraIconButton>;
};

export default IconButton;
